export default __webpack_public_path__ + "static/media/pyodide.32e546f9.ico";